export const assetModelPrecision = 10

export const cdfDataFileName = 'data.csv'

export const REPORT_ENTRY_UPLOAD_DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss.SSSSS'
